import { render, staticRenderFns } from "./StudentInfoList.vue?vue&type=template&id=33b25cc0&scoped=true"
import script from "./StudentInfoList.vue?vue&type=script&lang=js"
export * from "./StudentInfoList.vue?vue&type=script&lang=js"
import style0 from "./StudentInfoList.vue?vue&type=style&index=0&id=33b25cc0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b25cc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b25cc0')) {
      api.createRecord('33b25cc0', component.options)
    } else {
      api.reload('33b25cc0', component.options)
    }
    module.hot.accept("./StudentInfoList.vue?vue&type=template&id=33b25cc0&scoped=true", function () {
      api.rerender('33b25cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/studentInfo/StudentInfoList.vue"
export default component.exports